import Tour from './Tour'
import { HOME_PAGE_STEPS } from './steps/HomePageTourSteps'

export default Tour
export { HOME_PAGE_STEPS }
